import { injectIntl } from "react-intl";
import { Button, Card, CardActions, CardContent, Dialog, Typography } from "@mui/material";
import { getMessageString } from "../../utility";
import { CHIUDI, ACCETTA } from "../../modules/language";

export const ModalConsensi = injectIntl(({ intl, open, contenuto, onClose, onAccept, showAccept }) => (
  <>
    <Typography id={"modalConsensi_" + contenuto} sx={{ display: "none" }}>
      Modale allegati consensi
    </Typography>
    <Dialog open={open} className="modalConsensi" aria-labelledby={"modalConsensi_" + contenuto}>
      <Card>
        <CardContent>
          <iframe
            title={contenuto + ".pdf"}
            src={window.origin + "/risorse/" + contenuto + ".pdf"}
            type="application/pdf"
            width="100%"
            height="100%"
          />
        </CardContent>
        <CardActions>
          <Button variant="contained" onClick={onClose} className="chiudi">
            {getMessageString(intl, CHIUDI)}
          </Button>
          {showAccept && (
            <Button variant="contained" onClick={onAccept} className="accetta">
              {getMessageString(intl, ACCETTA)}
            </Button>
          )}
        </CardActions>
      </Card>
    </Dialog>
  </>
));
